const tableHeaders = [
  { name: "updatedAt", value: "Last Updated", sortable: true },
  { name: "naics", value: "NAICS", sortable: true },
  { name: "industryName", value: "Industry", sortable: true },
  { name: "businessName", value: "Business Name", sortable: true },
  { name: "status", value: "Status", sortable: true },
  { name: "estimatedByEmail", value: "Created By", sortable: true },
  { name: "year", value: "Year", sortable: true },
  { name: "employees", value: "# Emp", sortable: true },
  { name: "value", value: "Value", addClass: "left" },
];

const globalExcludedKeys = [
  "status",
  "businessName",
  "estimatedByEmail",
  "updatedAt",
  "value",
  "year",
];

const myEstimatesExcludedKeys = ["estimatedByEmail"];

const sharedExcludedKeys = ["status"];

const archivedExcludedKeys = ["status", "estimatedByEmail"];

const estimateTableHeaders = (name) => {
  const filters = {
    shared: (item) => !sharedExcludedKeys.includes(item.name),
    archived: (item) => !archivedExcludedKeys.includes(item.name),
    templates: (item) => !globalExcludedKeys.includes(item.name),
    user: (item) => !myEstimatesExcludedKeys.includes(item.name),
  };

  const filter = filters[name];
  if (!filter) {
    throw new Error(`${name} is not a valid filter`);
  }

  return tableHeaders.filter(filter);
};

export const archivedTableHeaders = () => estimateTableHeaders("archived");
export const sharedTableHeaders = () => estimateTableHeaders("shared");
export const templatesTableHeaders = () => estimateTableHeaders("templates");
export const userTableHeaders = () => estimateTableHeaders("user");
